<script setup lang="ts">
const props = defineProps<{
  milliQuantity?: number
}>()
</script>

<template>
  {{ props.milliQuantity ? props.milliQuantity / 1000 : '-' }}
</template>

<style scoped lang="scss"></style>
